import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { n: '01', label: 'understand', detail: 'frame the actual question before touching a table' },
  { n: '02', label: 'explore', detail: 'profile shape, nulls, types, obvious anomalies' },
  { n: '03', label: 'clean & validate', detail: 'fix types, dedupe, write tests for the assumptions' },
  { n: '04', label: 'transform', detail: 'model it the way the questions will actually be asked' },
  { n: '05', label: 'analyze', detail: 'SQL + Pandas to find what\'s actually true' },
  { n: '06', label: 'visualize', detail: 'Power BI — only after the numbers are trusted' },
];

export const CaseStudyHighlight: React.FC = () => {
  return (
    <section id="case-study" className="py-24 px-6 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-10"
        >
          <p className="font-mono text-sm text-accent mb-2">## how_i_work</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-text mb-3">pipeline, not guesswork</h2>
          <p className="text-muted max-w-2xl">
            The dashboard is the last step, not the first one. Every project here follows the
            same order — it's the difference between a chart that looks right and one that is.
          </p>
        </motion.div>

        <div className="relative border-l border-border ml-3">
          {steps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, x: -12 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="relative pl-8 pb-8 last:pb-0"
            >
              <span className="absolute -left-[7px] top-1 w-3.5 h-3.5 rounded-full bg-background border-2 border-accent" />
              <div className="flex items-baseline gap-3 flex-wrap">
                <span className="font-mono text-xs text-accent2">{step.n}</span>
                <h3 className="font-mono text-base text-text">{step.label}</h3>
              </div>
              <p className="text-sm text-muted mt-1">{step.detail}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
